export const PageTag = {
    SymbolTag: "符號",
    NumberTag: "數字",
};

export const NumberImgList = [
    "圖片1.png",
    "圖片2.png",
    "圖片3.png",
    "圖片4.png",
    "圖片5.png",
    "圖片6.png",
    "圖片7.png",
    "圖片8.png",
    "圖片9.png",
    "圖片10.png",
    "圖片11.png",
    "圖片12.png",
    "圖片13.png",
    "圖片14.png",
    "圖片15.png",
    "圖片16.png",
    "圖片17.png",
    "圖片18.png",
    "圖片19.png",
    "圖片20.png",
    "圖片21.png",
    "圖片22.png",
    "圖片23.png",
    "圖片24.png",
    "圖片25.png",
    "圖片26.png",
    "圖片27.png",
    "圖片28.png",
    "圖片29.png",
    "圖片30.png",
];
export const SymbolImgList = [
    "圖片31.png",
    "圖片32.png",
    "圖片33.png",
    "圖片34.png",
    "圖片35.png",
    "圖片36.png",
    "圖片37.png",
    "圖片38.png",
    "圖片39.png",
    "圖片40.png",
    "圖片41.png",
    "圖片42.png",
    "圖片43.png",
    "圖片44.png",
    "圖片45.png",
    "圖片46.png",
    "圖片47.png",
    "圖片48.png",
    "圖片49.png",
    "圖片50.png",
    "圖片51.png",
    "圖片52.png",
    "圖片53.png",
    "圖片54.png",
];
